import Vue from 'vue'
//import Vue from 'vue/dist/vue.js';

import VueSweetalert2 from 'vue-sweetalert2';
import App from './App.vue'

import axios from 'axios'
import VueAxios from 'vue-axios'
import VueRouter from 'vue-router'

import debounce from 'lodash/debounce';





import VModal from 'vue-js-modal';




import VueCookies from 'vue-cookies'
import 'sweetalert2/dist/sweetalert2.min.css';


import router from './router'
import vuetify from './plugins/vuetify'

import '@mdi/font/css/materialdesignicons.css'



import api from './utils/api';

export const bus = new Vue();

//Define app                 
window.context = "emt";

document.title = "EMT";

Vue.$api = api

Object.defineProperty(Vue.prototype, '$api', {
  get() {
    return api
  }
})



var loggedIn = window.$cookies.get("token");



Vue.use(VueCookies);
Vue.use(debounce);

Vue.use(VueSweetalert2);
Vue.use(VueAxios, axios);
Vue.use(VueRouter)


Vue.use(VModal, {
  dialog: true
});

Vue.config.ignoredElements = [/ion:*/]



if (loggedIn) {
  Vue.prototype.userLogged = true;

}


window.App = new Vue({
  router,
  vuetify,

  render: h => h(App)
}).$mount('#app')



if (loggedIn == null) {


  if (!document.location.hash.toString().includes("reservateCespiti") && (!document.location.hash.toString().includes("reservateCustomerSupplier")) && (!document.location.hash.toString().includes("reservate")) && (!document.location.hash.toString().includes("initReservateCespiti")) && (!document.location.hash.toString().includes("datiCollaboratore"))) {




    router.push({ path: '/' }).catch(() => { });

  }






}